"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRACE_HEADER = void 0;
exports.applyTracingHeader = applyTracingHeader;
const random_1 = require("./random");
const TRACE_ID_HEX_SIZE = 32;
const PARENT_ID_HEX_SIZE = 16;
const VERSION = '00';
const TRACE_FLAGS = '00';
exports.TRACE_HEADER = 'traceparent';
/**
 * Creates and applies the 'traceparent' header to the axios config
 * @param config InternalAxiosRequestConfig
 * @returns InternalAxiosRequestConfig
 */
function applyTracingHeader(config) {
    var _a, _b;
    // Don't remove any existing trace header
    if ((_a = config.headers) === null || _a === void 0 ? void 0 : _a[exports.TRACE_HEADER]) {
        return config;
    }
    const traceId = (0, random_1.createRandomHexNumber)(TRACE_ID_HEX_SIZE);
    const parentId = (0, random_1.createRandomHexNumber)(PARENT_ID_HEX_SIZE);
    config.headers = (_b = config.headers) !== null && _b !== void 0 ? _b : {};
    config.headers[exports.TRACE_HEADER] = `${VERSION}-${traceId}-${parentId}-${TRACE_FLAGS}`;
    return config;
}
//# sourceMappingURL=tracing.js.map